import { MACRONUTRIENT_STATUS_LABELS } from '../constants/maintenance.constants';
import type {
	SimpleDataTableColumn,
	SimpleDataTableRow,
} from '../components/Tables/SimpleDataTable/SimpleDataTable';
import { classifyCoverage } from './coverage';
import type { MaintenanceNutritionTableResponse } from '../types';

export interface NutrientStatusTableGroup {
	title: string;
	columns: SimpleDataTableColumn[];
	rows: SimpleDataTableRow[];
}

const NUTRIENT_STATUS_COLUMNS: SimpleDataTableColumn[] = [
	{ key: 'nutrient', label: 'NUTRIENTE', emphasis: 'strong' },
	{ key: 'annualDemand', label: 'DEMANDA ANUAL', emphasis: 'default', align: 'right' },
	{ key: 'supplied', label: 'FORNECIDO', emphasis: 'muted', align: 'right' },
	{ key: 'coverage', label: 'COBERTURA', variant: 'coverage' },
	{ key: 'metStatus', label: 'DEMANDA ATENDIDA', variant: 'status', align: 'right' },
];

const displayValue = (value: number | null | undefined): string =>
	typeof value === 'number' && Number.isFinite(value) ? `${value} kg/ha` : '—';

export const mapMaintenanceAnnualNutritionRows = (
	response?: MaintenanceNutritionTableResponse
): NutrientStatusTableGroup[] => {
	if (!response?.tableAnnual) return [];

	const rows: SimpleDataTableRow[] = MACRONUTRIENT_STATUS_LABELS.flatMap(({ key, label }) => {
		const values = response.tableAnnual[key];
		if (!values) return [];

		const [annualDemand, supplied, percentage] = values;
		const hasCoverage = typeof percentage === 'number' && Number.isFinite(percentage);

		return [
			{
				id: key,
				cells: {
					nutrient: label,
					annualDemand: displayValue(annualDemand),
					supplied: displayValue(supplied),
				},
				coverage: hasCoverage
					? {
							coverage: {
								percentage: percentage as number,
								status: classifyCoverage(percentage as number),
							},
							metStatus: {
								percentage: percentage as number,
								status: classifyCoverage(percentage as number),
							},
						}
					: undefined,
			},
		];
	});

	if (rows.length === 0) return [];

	return [{ title: 'Macronutrientes', columns: NUTRIENT_STATUS_COLUMNS, rows }];
};
